import { types } from '../types/types';
import { fetchSinToken, fetchConToken } from '../../helpers/fetch';
import { toast } from 'react-toastify';

export const startLogin = (email, password) => {
    return async (dispatch) => {

        const resp = await fetchSinToken('auth', { email, password }, 'POST');
        const body = await resp.json();

        if (body.ok) {
            localStorage.setItem('token', body.token);
            localStorage.setItem('token-init-date', new Date().getTime());

            dispatch(login({
                uid: body.uid,
                name: body.name,
                email: body.email,
                access: body.access,
                perfil: body.perfil,
                alias: body.alias,
                alias_mostrar: body.alias_mostrar
            }));

            // 🔹 redirección inteligente
            const redirect = localStorage.getItem('redirectAfterLogin');
            if (redirect) {
                localStorage.removeItem('redirectAfterLogin');
                window.location.href = redirect;
            }

        } else {
            toast.error(body.msg)
            console.log(body.msg);
        }

    }
}

export const startCheking = () => {
    return async (dispatch) => {

        const resp = await fetchConToken('auth/renew');
        const body = await resp.json();

        if (body.ok) {
            localStorage.setItem('token', body.token);
            localStorage.setItem('token-init-date', new Date().getTime());

            dispatch(login({
                uid: body.uid,
                name: body.name,
                email: body.email,
                url_foto: body.url_foto,
                access: body.access,
                perfil: body.perfil,
                alias: body.alias,
                alias_mostrar: body.alias_mostrar
            }));


        } else {

            dispatch(checkingFinish());
        }


    }
}

export const startLogout = () => {
    return (dispatch) => {
        localStorage.clear();
        dispatch(logout());
    }
}

const checkingFinish = () => ({
    type: types.authCheckingFinish
});

const login = (user) => ({
    type: types.authLogin,
    payload: user
});

const logout = () => ({
    type: types.authLogout,
});

export const authUpdatePhoto = (newUrl) => ({
    type: types.authUpdatePhoto,
    payload: newUrl
});

